<script lang="ts" setup>
import { computed } from 'vue';

/**
 * EzTableRowコンポーネントのプロパティ
 * @property {string[]} gridTemplateColumns - グリッドの各列の幅を定義する配列
 * @property {boolean} isHighlighted - 行をハイライト表示するかどうか
 * @property {boolean} isExpanded - 行が展開されているかどうか
 * @property {boolean} isLoading - 行のロード中状態を表すかどうか
 * @property {boolean} isError - エラー状態を表すかどうか
 * @property {boolean} isChild - 子行かどうか
 */
type Props = {
  gridTemplateColumns: string[];
  isHighlighted?: boolean;
  isExpanded?: boolean;
  isLoading?: boolean;
  isError?: boolean;
  isChild?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  isHighlighted: false,
  isExpanded: false,
  isLoading: false,
  isError: false,
  isChild: false,
});

const emits = defineEmits<{ (e: 'click') }>();

const gridTemplateColumnsStyle = computed(() => {
  return props.gridTemplateColumns.join(' ');
});

/**
 * 行のCSSクラスを計算
 */
const rowClasses = computed(() => {
  return {
    'table__row--highlighted': props.isHighlighted,
    'table__row--expanded': props.isExpanded,
    'table__row--loading': props.isLoading,
    'table__row--error': props.isError,
    'table__row--child': props.isChild,
  };
});
</script>

<template>
  <div class="table__row" :class="rowClasses" @click="emits('click')">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.table__row {
  display: grid;
  grid-template-columns: v-bind(gridTemplateColumnsStyle);
  width: 100%;

  &--highlighted {
    background-color: var(--highlighted-bg, #f8f9fa);
  }

  &--expanded {
    background-color: var(--expanded-bg, #f5f7fa);
  }

  &--loading {
    opacity: 0.7;
  }

  &--error {
    background-color: var(--error-bg, #fff5f5);
  }

  &--child {
    padding-left: 20px;
    background-color: var(--child-bg, #f8f9fa);
  }
}
</style>
